module.exports = __webpack_public_path__ + "img/finance-professional.8cf57034.png";